import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Button, Card } from "flowbite-react";
import Input from "../inputs/Input";
import SelectInput from "../inputs/SelectInput";
import CPFInput from "../inputs/CPFInput";
import AutoCompleteInput from "../inputs/Autocomplete";
import SurveySection from "./SurveySection";
import * as yup from "yup";
import { SURVEYS, USERS } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import CNPJInput from "../inputs/CNPJInput";
import CurrencyInput from "../inputs/CurrencyInput";

const schema = yup.object().shape({
  // ownerName: yup.string().required("O nome do proprietário é obrigatório"),
  // ownerDocument: yup.string().required("O documento é obrigatório"),
  // ownerType: yup.string().required("O tipo do proprietário é obrigatório"),
  typePayment: yup.string().required("A forma de pagamento é obrigatória"),
  typistId: yup.string().required("O digitador é obrigatório"),
  surveyorId: yup.string().required("O vistoriador é obrigatório"),
  price: yup
    .number()
    .transform((value, originalValue) =>
      typeof originalValue === "string" && originalValue.trim() === ""
        ? null
        : value
    )
    .required("O preço do laudo é obrigatório")
    .min(0, "O preço não pode ser negativo"),
});

const SurveyCustomer = ({ setActiveStep, survey, setSurvey }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    isLoading: isLoadingUsers,
    error: errorUsers,
    data: users,
  } = useQuery(["users"], async () => {
    const { data } = await axios.get(`${USERS.GET_USERS}`);

    let users = data.data.data.map((user) => ({
      label: user.name,
      value: user.id,
    }));

    return users;
  });

  useEffect(() => {
    if (survey) {
      Object.keys(survey).forEach((s) => {
        setValue(s, survey[s]);
      });
    }
  }, []);

  const onSubmit = async (data) => {
    setError(null);
    setIsSubmitting(true);
    try {
      if (survey && survey.id) data.id = survey.id;
      const response = await axios.post(SURVEYS.GET_SURVEY, data);
      data.id = response.data[0].id;
      setSurvey(data);

      setActiveStep(2);
    } catch (error) {
      setError("Erro ao tentar salvar o laudo!");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <SurveySection name="Dados do proprietário">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <Input
              register={register}
              name="ownerName"
              label="Nome do proprietário"
            />
            {errors.ownerName?.message && (
              <small className="text-red-600">
                {errors.ownerName?.message}
              </small>
            )}
          </div>

          <div>
            <SelectInput
              register={register}
              name="ownerType"
              label="Tipo do proprietário"
            >
              <option value={1}>Pessoa física</option>
              <option value={2}>Pessoa jurídica</option>
            </SelectInput>
            {errors.ownerType?.message && (
              <small className="text-red-600">
                {errors.ownerType?.message}
              </small>
            )}
          </div>

          {watch("ownerType") == 1 ? (
            <div>
              {" "}
              <CPFInput
                register={register}
                name="ownerDocument"
                label="CPF do proprietário"
              />
              {errors.ownerDocument?.message && (
                <small className="text-red-600">
                  {errors.ownerDocument?.message}
                </small>
              )}
            </div>
          ) : (
            <div>
              {" "}
              <CNPJInput
                register={register}
                name="ownerDocument"
                label="CNPJ do proprietário"
              />
              {errors.ownerDocument?.message && (
                <small className="text-red-600">
                  {errors.ownerDocument?.message}
                </small>
              )}
            </div>
          )}
        </div>
      </SurveySection>

      <SurveySection name="Dados de pagamento">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <SelectInput
              register={register}
              name="typePayment"
              label="Forma de pagamento"
            >
              <option value="">Selecione</option>
              <option>A vista</option>
              <option>Cartão de crédito</option>
              <option>Cartão de débito</option>
              <option>Dinheiro</option>
              <option>Pix</option>
              <option>Boleto</option>
            </SelectInput>
            {errors.typePayment?.message && (
              <small className="text-red-600">
                {errors.typePayment?.message}
              </small>
            )}
          </div>
          <div>
            <CurrencyInput
              register={register}
              name="price"
              label="Preço"
              required={true}
              control={control}
            />
            {errors.price?.message && (
              <small className="text-red-600">{errors.price?.message}</small>
            )}
          </div>
        </div>
      </SurveySection>

      <SurveySection name="Dados do funcionário">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <AutoCompleteInput
              register={register}
              name="typistId"
              label="Digitador"
              options={users}
              isLoading={isLoadingUsers}
              value={watch("typistId")}
              onChange={(user) => setValue("typistId", user.value)}
            />
            {errors.typistId?.message && (
              <small className="text-red-600">{errors.typistId?.message}</small>
            )}
          </div>
          <div>
            <AutoCompleteInput
              register={register}
              name="surveyorId"
              label="Vistoriador"
              options={users}
              isLoading={isLoadingUsers}
              value={watch("surveyorId")}
              onChange={(user) => setValue("surveyorId", user.value)}
            />
            {errors.surveyorId?.message && (
              <small className="text-red-600">
                {errors.surveyorId?.message}
              </small>
            )}
          </div>
        </div>
      </SurveySection>

      <div className="flex justify-center items-center gap-2 mt-10">
        <Button
          type="submit"
          className="primary"
          disabled={isSubmitting}
          isProcessing={isSubmitting}
        >
          {!isSubmitting ? "Próximo" : "Salvando..."}
        </Button>
      </div>
      {error && (
        <Alert color="failure" withBorderAccent className="mt-4">
          Erro ao tentar salvar o laudo! Tente novamente mais tarde.
        </Alert>
      )}
    </form>
  );
};

export default SurveyCustomer;
